const ZambiaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112810)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#496E2D"
      />
      <path
        d="M27.8261 20H20V40C22.3378 40 24.5813 39.5976 26.6666 38.8605L27.8261 20Z"
        fill="#D80027"
      />
      <path
        d="M33.3337 34.9057C37.4249 31.2437 40.0004 25.9229 40.0004 20H32.1743L33.3337 34.9057Z"
        fill="#FF9811"
      />
      <path
        d="M26.6665 20V38.8605C29.1506 37.9823 31.4095 36.6277 33.3332 34.9058V20H26.6665Z"
        fill="black"
      />
      <path
        d="M36.9566 13.0438H31.7392C31.7392 12.0834 30.9605 11.3047 30 11.3047C29.0396 11.3047 28.2609 12.0834 28.2609 13.0438H23.0435C23.0435 14.0044 23.8801 14.783 24.8405 14.783H24.7826C24.7826 15.7435 25.5611 16.5221 26.5217 16.5221C26.5217 17.4827 27.3003 18.2613 28.2609 18.2613H31.7392C32.6996 18.2613 33.4783 17.4827 33.4783 16.5221C34.4388 16.5221 35.2174 15.7435 35.2174 14.783H35.1596C36.12 14.7829 36.9566 14.0043 36.9566 13.0438Z"
        fill="#FF9811"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112810">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default ZambiaSvg;
